/* ═══════════════════════════════════════════════════════════
   Edge of Life Designs — Product Page JS
   assets/eol-product.js
═══════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  var product = window.EOLProductData;
  if (!product) return;

  var variants = product.variants;

  // ── Helpers ──────────────────────────────────────────────
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    return '$' + amount;
  }

  // ── Gallery ───────────────────────────────────────────────
  var mainImage = $('[data-main-image]');
  var thumbs = $$('[data-thumb]');

  function setMainImage(src, alt) {
    if (!mainImage) return;
    mainImage.src = src;
    if (alt) mainImage.alt = alt;
  }

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      setMainImage(thumb.dataset.src, thumb.dataset.alt);
    });
  });

  // ── Variant Selection ─────────────────────────────────────
  var selectedOptions = [];

  // Initialise from currently selected variant
  var currentVariantId = parseInt($('[data-variant-id]').value);
  var currentVariant = variants.find(function (v) { return v.id === currentVariantId; });
  if (currentVariant) {
    selectedOptions = currentVariant.options.slice();
  }

  var variantBtns = $$('[data-option-value]');

  variantBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var optionIndex = parseInt(btn.dataset.optionIndex);
      var optionValue = btn.dataset.optionValue;

      selectedOptions[optionIndex] = optionValue;

      // Update active state within this option group
      var groupBtns = $$('[data-option-index="' + optionIndex + '"]');
      groupBtns.forEach(function (b) { b.classList.remove('is-selected'); });
      btn.classList.add('is-selected');

      updateVariant();
    });
  });

  function findVariant(options) {
    return variants.find(function (v) {
      return v.options.every(function (opt, i) {
        return opt === options[i];
      });
    });
  }

  function updateVariant() {
    var variant = findVariant(selectedOptions);
    if (!variant) return;

    // Update hidden input
    var variantInput = $('[data-variant-id]');
    if (variantInput) variantInput.value = variant.id;

    // Update URL
    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());

    // Update price
    updatePrice(variant);

    // Update ATC button
    updateAtcBtn(variant);

    // Update image if variant has one
    if (variant.featured_image) {
      var src = variant.featured_image.src;
      var alt = variant.featured_image.alt || product.title;
      setMainImage(src, alt);

      // Activate matching thumb
      thumbs.forEach(function (t) {
        t.classList.remove('is-active');
        if (t.dataset.src === src) t.classList.add('is-active');
      });
    }
  }

  // ── Price ─────────────────────────────────────────────────
  function updatePrice(variant) {
    var wrap = $('[id^="eol-price-"]');
    if (!wrap) return;

    var html = '';
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      var savings = variant.compare_at_price - variant.price;
      var pct = Math.round(savings / variant.compare_at_price * 100);
      html += '<span class="eol-price eol-price--sale">' + formatMoney(variant.price) + '</span>';
      html += '<span class="eol-price eol-price--compare"><s>' + formatMoney(variant.compare_at_price) + '</s></span>';
      html += '<span class="eol-price__badge">Save ' + pct + '%</span>';
    } else {
      html += '<span class="eol-price">' + formatMoney(variant.price) + '</span>';
    }
    wrap.innerHTML = html;
  }

  // ── ATC Button ────────────────────────────────────────────
  function updateAtcBtn(variant) {
    var btn = $('[data-atc-btn]');
    var txt = $('[data-atc-text]');
    if (!btn) return;
    if (variant.available) {
      btn.disabled = false;
      if (txt) txt.textContent = 'Add to Cart';
    } else {
      btn.disabled = true;
      if (txt) txt.textContent = 'Sold Out';
    }
  }

  // ── Quantity ──────────────────────────────────────────────
  var qtyInput = $('[class="eol-quantity__input"]');
  var qtyMinus = $('[data-qty-minus]');
  var qtyPlus  = $('[data-qty-plus]');

  if (qtyMinus && qtyInput) {
    qtyMinus.addEventListener('click', function () {
      var val = parseInt(qtyInput.value) || 1;
      qtyInput.value = Math.max(1, val - 1);
    });
  }

  if (qtyPlus && qtyInput) {
    qtyPlus.addEventListener('click', function () {
      var val = parseInt(qtyInput.value) || 1;
      qtyInput.value = val + 1;
    });
  }

  // ── Accordions ────────────────────────────────────────────
  var accordionTriggers = $$('[data-accordion-trigger]');

  accordionTriggers.forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var body = trigger.parentElement.querySelector('[data-accordion-body]');
      var isOpen = trigger.getAttribute('aria-expanded') === 'true';

      if (isOpen) {
        trigger.setAttribute('aria-expanded', 'false');
        body.classList.remove('is-open');
      } else {
        trigger.setAttribute('aria-expanded', 'true');
        body.classList.add('is-open');
      }
    });
  });

  // ── Recommendations ───────────────────────────────────────
  var recSection = $('[data-recommendations]');
  if (recSection) {
    var productId = recSection.dataset.productId;
    var limit = recSection.dataset.limit || 4;
    var grid = $('[data-rec-grid]');

    fetch('/recommendations/products.json?product_id=' + productId + '&limit=' + limit)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data.products || !data.products.length) {
          recSection.style.display = 'none';
          return;
        }
        var html = data.products.map(function (p) {
          var imgSrc = p.featured_image ? p.featured_image : '';
          var imgTag = imgSrc
            ? '<img class="eol-rec-item__img" src="' + imgSrc + '" alt="' + p.title.replace(/"/g, '&quot;') + '" loading="lazy">'
            : '<div class="eol-rec-item__img"></div>';
          var price = (p.variants && p.variants[0]) ? formatMoney(p.variants[0].price) : '';
          return '<a href="/products/' + p.handle + '" class="eol-rec-item">'
            + imgTag
            + '<span class="eol-rec-item__title">' + p.title + '</span>'
            + '<span class="eol-rec-item__price">' + price + '</span>'
            + '</a>';
        }).join('');
        grid.innerHTML = html;
      })
      .catch(function () {
        if (recSection) recSection.style.display = 'none';
      });
  }

})();
